/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AreaUpdate { 
    Name?: string | null;
    HeatmapInterval?: number | null;
    Id: string;
    BackgroundImage?: string | null;
    Width?: number | null;
    Height?: number | null;
    CellsX?: number | null;
    CellsY?: number | null;
    Index?: number | null;
    GatewayMacAddress?: string | null;
}

